// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousWednesday as fn } from "../previousWednesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousWednesday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default previousWednesday;
